import { Dialog } from '@ordr-as/umami-react'
import { FavritApp, PaymentMethodLocationConnectionDto } from '../../generated-api'
import { useCreatePaymentMethodLocationConnection } from 'hooks/usePaymentMethodApi'
import { mapFavritAppToName } from 'utils/favritAppUtils'

type RemoveAppFromLocationDialogProps = {
    locationConnection: PaymentMethodLocationConnectionDto
    favritApp: FavritApp
    dialogIsOpen: boolean
    onClose: () => void
}

const RemoveAppFromLocationDialog = (props: RemoveAppFromLocationDialogProps) => {
    const { locationConnection, favritApp, dialogIsOpen, onClose } = props

    const { mutate: runCreateLocationConnection, isLoading: isCreatingLocationConnection } =
        useCreatePaymentMethodLocationConnection(
            locationConnection.paymentProvider,
            locationConnection.paymentMethod,
            locationConnection.locationId
        )

    const handleRemoveApp = () => {
        const updatedApps = new Set(locationConnection.enabledInApps)
        updatedApps.delete(favritApp)

        runCreateLocationConnection(
            {
                locationId: locationConnection.locationId,
                enabledInApps: updatedApps,
                overridableConfiguration: locationConnection.overridableConfiguration ?? undefined,
            },
            {
                onSuccess: () => {
                    onClose()
                },
            }
        )
    }

    return (
        <div className="inline-block group relative flex-none">
            {dialogIsOpen && (
                <Dialog
                    title="Remove app"
                    onClose={() => onClose()}
                    actionLabel={isCreatingLocationConnection ? 'Removing...' : 'Remove app'}
                    onAction={handleRemoveApp}
                    secondaryActionLabel={'Cancel'}
                    onSecondaryAction={() => {
                        onClose()
                    }}
                    isDisabledAction={isCreatingLocationConnection}
                    isDisabledSecondaryAction={isCreatingLocationConnection}
                >
                    This will remove the {locationConnection.paymentProvider} - {locationConnection.paymentMethod}{' '}
                    payment method from the <span className="text-bold">{mapFavritAppToName(favritApp)}</span> for
                    location {locationConnection.locationId}.
                </Dialog>
            )}
        </div>
    )
}

export default RemoveAppFromLocationDialog
